import location from '@/api/product/location-storage'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
}

export const getters = {}

export const mutations = {
  ...baseMutations,
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
            search : context.state.search
        }
      },
      attrubutes
    )
    return location.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return location.store(data)
  },
  update(context, { id, data }) {
    return location.update(id, data)
  },
  destroy(context, id) {
    return location.destroy(id)
  }
}